import { render, staticRenderFns } from "./SalarySystem.vue?vue&type=template&id=b0558a72&scoped=true&"
import script from "./SalarySystem.vue?vue&type=script&lang=js&"
export * from "./SalarySystem.vue?vue&type=script&lang=js&"
import style0 from "./SalarySystem.vue?vue&type=style&index=0&id=b0558a72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0558a72",
  null
  
)

export default component.exports